export default __webpack_public_path__ + "static/media/test9.2c0e7f4a.png";